export const FEATURE_NAMESPACE = 'feature.expert-system-usage-rate'
